const AppConfig = require('./app-config');

const api = {
  success: 'success',
  failure: 'failure',
  unauthorized: 'unauthorized',
  loading: 'loading',
  emailExists: 'email exists',
};

const intercomAppId = 'kll38juf';
const intercomApiKey = 'gwBqH__Hx-ztL70JqXVT4DnOXpugZhNKepf7HKga';

const platform = {
  web: 'web',
  ios: 'ios',
  android: 'android',
  android_rom: 'android_rom',
  android_wht: 'android_wht',
  notDefined: 'notDefined',
};

const platformType = {
  android: platform.android,
  ios: platform.ios,
  web: platform.web,
  android_rom: platform.android,
  android_wht: platform.android,
};

const sdk = {
  success: 'success',
  loading: 'loading',
  failure: 'failure',
};

module.exports = {
  api,
  apiUrl: AppConfig.apiUrl,
  apiClientId: AppConfig.apiClientId,
  apiClientSecret: AppConfig.apiClientSecret,
  intercomAppId,
  intercomApiKey,
  platform,
  platformType,
  sdk,
};



// WEBPACK FOOTER //
// ./src/helper/constants.js